module.exports = {
      id: "icon-audio-twitter-usage",
      viewBox: "0 0 25.209 25.209",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-audio-twitter",
      toString: function () {
        return this.url;
      }
    }